import { type DocumentTableRow } from 'features/knowledgeDocumentViewer'
import React from 'react'
import styled from 'styled-components'

import {
  Field,
  FieldDescription,
  FieldTitle,
} from '@/src/designSystem/components/Field'

const MetaGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 0.5rem;
  flex-shrink: 0;
`

const MetaDetail: React.FC<{
  label: string
  children: React.ReactNode
}> = ({ label, children }) => (
  <Field orientation='vertical'>
    <FieldTitle>{label}</FieldTitle>
    <FieldDescription>{children}</FieldDescription>
  </Field>
)

export const DocumentPreviewMeta: React.FC<{ document: DocumentTableRow }> = ({
  document,
}) => (
  <MetaGrid>
    {document.docType && (
      <MetaDetail label='Type'>{document.docType}</MetaDetail>
    )}
    {document.system && (
      <MetaDetail label='System'>{document.system}</MetaDetail>
    )}
    {document.vendor && (
      <MetaDetail label='Vendor'>{document.vendor}</MetaDetail>
    )}
    {document.numPages !== null && (
      <MetaDetail label='Pages'>{document.numPages}</MetaDetail>
    )}
    {(document.revisionCode || document.revisionDate) && (
      <MetaDetail label='Revision'>
        {document.revisionCode || '-'}
        {document.revisionDate && ` (${document.revisionDate})`}
      </MetaDetail>
    )}
    {document.drawing && (
      <MetaDetail label='Drawing'>{document.drawing}</MetaDetail>
    )}
  </MetaGrid>
)
